module.exports = __webpack_public_path__ + "img/windows-2-tw.17798050.png";